@import 'styles/mixins';
@import 'styles/variables';

.root {
  align-items: center;
  display: flex;
  padding: 6px 6px 6px 8px;
  border-radius: 6px;

  &:hover {
    cursor: pointer;
  }

  &.highlighted {
    background: var(--neutral-5);
  }
}

.expandedContents {
  background-color: var(--white);
  max-height: 0;
  overflow: hidden;
  padding-left: 24px;
  transition: max-height 0.5s ease-in-out;

  .root {
    &:hover {
      cursor: default;
    }
  }

  &.showing {
    max-height: 10000px;
    transition: max-height 2s ease-in-out;
  }
}

.titleContainer {
  align-items: center;
  display: flex;
  margin-left: 6px;
}

.chevron {
  align-items: center;
  display: flex;
  margin-left: 2px;

  &:hover {
    background-color: var(--neutral-5);
  }

  svg {
    fill: var(--neutral-40);
  }
}

.title {
  @include line-clamp;
  @include md-regular;

  align-items: center;
  color: var(--neutral-90);
  max-width: 300px;

  @include for-phone-only {
    max-width: 220px;
  }
}

.description {
  @include sm-regular;
  color: var(--neutral-40);
  margin-left: 6px;
}
